'use client';

import { useEffect, useState } from 'react';
import { ChangeStepFormEvent } from '@/components/getStarted/multi-step-form/multi-step-form.model';
import styles from './RangeInput.module.css';
import layoutStyles from '@/components/getStarted/multi-step-form/layout.module.css';

type Props = {
  min: number;
  max: number;
  plusIndicator?: boolean;
  value?: number;
  onValueChange?: (value: number) => void;
  onChange: (e: ChangeStepFormEvent) => void;
  name: string;
};

export const RangeInput = ({
  min,
  max,
  value,
  onValueChange,
  onChange,
  name,
  plusIndicator = true,
}: Props) => {
  const [range, setRange] = useState(value ? value : 1);

  const handleOnChange = (newValue: React.ChangeEvent<HTMLInputElement>) => {
    onChange(newValue);
    if (onValueChange) {
      onValueChange(+newValue.target.value);
    }
    setRange(+newValue.target.value);
  };
  useEffect(() => {
    // update default value in form so required fields are not empty
    if (!value) {
      onChange({ target: { name, value: 1 } });
    }
  }, [range, value, onChange, name]);
  return (
    <div
      className={`${styles.rangeContainer} ${layoutStyles.item}`}
      data-value={`${range}${range === max && plusIndicator ? '+' : ''}`}
      style={
        {
          '--value-position': `${((range - min) / (max - min)) * 100}%`,
        } as React.CSSProperties
      }
    >
      <span className={styles.rangeStartDotIndicator}></span>
      <input
        name={name}
        type="range"
        min={min}
        max={max}
        value={range}
        onChange={(e) => handleOnChange(e)}
        className={styles.rangeInput}
      />
      <div className={styles.rangeLabels}>
        <span>{min}</span>
        <span>
          {max}
          {plusIndicator ? '+' : ''}
        </span>
      </div>
    </div>
  );
};
